export const Statuses = {
  UPLOAD_DICOM: "UPLOAD DICOM",
  IN_PROGRESS: "IN PROGRESS",
  READY: "READY",
  DEMO: "DEMO",
};
